import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('BLOG_AI_TOKEN') || '',
    user: JSON.parse(localStorage.getItem('BLOG_AI_USER') || 'null')
  },
  mutations: {
    setAuth(state, payload) {
      state.token = payload.token
      state.user = payload
      localStorage.setItem('BLOG_AI_TOKEN', payload.token)
      localStorage.setItem('BLOG_AI_USER', JSON.stringify(payload))
    },
    logout(state) {
      state.token = ''
      state.user = null
      localStorage.removeItem('BLOG_AI_TOKEN')
      localStorage.removeItem('BLOG_AI_USER')
    }
  }
})
